<template>
    <q-page class="q-pa-md  full-height">
        <q-card class="q-pa-md q-mt-md   full-height" style="max-height: calc(100vh - 120px);">
            <div class="row q-col-gutter-md full-height">
                <div class="col-3 full-height" style="border-right: 1px solid #E2E2E2;">
                    <div class="row q-col-gutter-md">
                        <div class="col-12 text-center">
                            <div class="relative-position inline-block">
                                <q-avatar size="200px">
                                    <img :src="imagenPerfil" />
                                </q-avatar>

                                <!-- Ícono de editar -->
                                <q-btn icon="mdi-pencil" color="primary" size="md" round
                                    class="absolute-bottom-right q-mb-xs q-mr-xs" @click="seleccionarFoto" />

                                <!-- Selector de archivo oculto -->
                                <input ref="fileInput" type="file" accept="image/*" style="display: none"
                                    @change="cambiarFoto" />
                            </div>
                        </div>

                        <div class="col-12">
                            <q-list class="text-primary q-pa-md">
                                <q-item clickable v-ripple :active="link === 'inbox'" @click="link = 'inbox'"
                                    active-class="my-menu-link" class="rounded-borders">
                                    <q-item-section avatar>
                                        <q-icon name="inbox" class=" class-menu-icono" />
                                    </q-item-section>
                                    <q-item-section>
                                        Mi Perfil
                                    </q-item-section>
                                </q-item>



                                <q-item clickable v-ripple :active="link === 'Fiscal'" @click="link = 'Fiscal'"
                                    active-class="my-menu-link" class="rounded-borders">
                                    <q-item-section avatar>
                                        <q-icon name="mdi-file-document-edit" class="class-menu-icono" />
                                    </q-item-section>
                                    <q-item-section>
                                        Datos Fiscales
                                    </q-item-section>
                                </q-item>
                                <q-item clickable v-ripple :active="link === 'Legales'" @click="link = 'Legales'"
                                    active-class="my-menu-link" class="rounded-borders">
                                    <q-item-section avatar>
                                        <q-icon name="mdi-file-document-edit" class="class-menu-icono" />
                                    </q-item-section>
                                    <q-item-section>
                                        Datos Legales
                                    </q-item-section>
                                </q-item>
                                <q-item clickable v-ripple :active="link === 'domicilio'" @click="link = 'domicilio'"
                                    active-class="my-menu-link" class="rounded-borders">
                                    <q-item-section avatar>
                                        <q-icon name="mdi-account-cash" class="class-menu-icono" />
                                    </q-item-section>
                                    <q-item-section>
                                        Domicilio
                                    </q-item-section>
                                </q-item>

                                <q-item clickable v-ripple :active="link === 'Documentos'" @click="link = 'Documentos'"
                                    active-class="my-menu-link" class="rounded-borders">
                                    <q-item-section avatar>
                                        <q-icon name="mdi-clipboard-text" class="class-menu-icono" />
                                    </q-item-section>
                                    <q-item-section>
                                        Documentos
                                    </q-item-section>
                                </q-item>



                                <q-item clickable v-ripple :active="link === 'seguridad'" @click="link = 'seguridad'"
                                    active-class="my-menu-link" class="rounded-borders">
                                    <q-item-section avatar>
                                        <q-icon name="mdi-file-document-edit" class="class-menu-icono" />
                                    </q-item-section>
                                    <q-item-section>
                                        Seguridad
                                    </q-item-section>
                                </q-item>
                            </q-list>
                        </div>
                    </div>
                </div>
                <div class="col-9 q-pa-xl " style="height: 100%; overflow-y: auto;">
                    <component :is="link === 'inbox' ? 'DatosGenerales' : null" />
                    <component :is="link === 'domicilio' ? 'Domicilio' : null" />
                    <component :is="link === 'Documentos' ? 'Biblioteca' : null" />
                    <component :is="link === 'Fiscal' ? 'InformacionFiscal' : null" />
                    <component :is="link === 'Legales' ? 'DatosLegales' : null" />
                    <component :is="link === 'seguridad' ? 'Seguridad' : null" />
                </div>
            </div>
        </q-card>
    </q-page>
</template>
<script>
import { QSpinnerClock } from 'quasar'
import axios from 'axios'

import { mapActions } from 'vuex'
import DatosGenerales from './DatosGenerales.vue';
import Domicilio from './Domicilio.vue';
import Biblioteca from './Biblioteca.vue';
import InformacionFiscal from './InformacionFiscal.vue';
import DatosLegales from './DatosLegales.vue';
import Seguridad from './Seguridad.vue';
export default {
    components: {
        DatosGenerales,
        Domicilio,
        Biblioteca,
        InformacionFiscal,
        DatosLegales,
        Seguridad
    },
    data() {
        return {
            text: '',
            link: 'inbox',
            imagenPerfil: ''
        };
    },
    created() {
    },
    computed: {
        usuarioStore() {
            return this.$store.state.auth.usuario;
        },

    },
    methods: {
        seleccionarFoto() {
            this.$refs.fileInput.click()
        },
        cambiarFoto(e) {
            this.$q.loading.show({ spinner: QSpinnerClock, spinnerColor: 'white', spinnerSize: 90, message: 'Guardando información. Espere...', messageColor: 'white' })

            const file = e.target.files[0]
            if (file) {
                const reader = new FileReader()
                reader.onload = async (event) => {
                    const base64Image = event.target.result
                    this.imagenPerfil = base64Image

                    try {
                        await axios.post('Configuracion/GuardarFotoPerfil', {
                            idUsuario: this.usuarioStore._id,
                            imagenBase64: base64Image
                        })
                        this.$q.loading.hide()
                        this.obtenerPerfil()
                        this.$q.notify({ type: 'positive', position: 'top-right', message: 'Foto de perfil actualizada' })
                    } catch (err) {
                        this.$q.loading.hide()

                        this.$q.notify({ type: 'negative', position: 'top-right', message: 'Error al guardar la foto' })
                    }
                }
                reader.readAsDataURL(file)
            }
        },

        async obtenerPerfil() {
            try {
                const res = await axios.get('Configuracion/GetFotoUsuarioPorId/' + this.usuarioStore._id)
                this.imagenPerfil = res.data
                this.$store.state.auth.usuario.fotoPerfilBase64 = res.data

            } catch (err) {
                console.error('Error al obtener perfil:', err)
            }
        }
    },
    mounted() {
        this.obtenerPerfil()
    },
};
</script>

<style scoped>
.bg-purple {
    background: linear-gradient(45deg, #6a52fa, #a17ff9);
}

.class-menu-icono {
    color: #697A8D;
}

.my-menu-link {
    color: white;
    background: #0094CA;
}

.my-menu-link i {
    color: white;
}

.q-page-container {
    overflow: hidden;
}

.mini-logo-container {
    padding: 8px !important;
    /* Ajusta el padding para el modo mini */
}

/* Puedes ajustar el color de fondo si lo deseas */
.q-drawer.bg-white {
    background-color: #ffffff;
}
</style>
| Campo | Descripción |
| ----------------------- | ---------------------------------------------------------------------- |
| `tipo_persona` | `"Física"` o `"Moral"` |
| `nombre_o_razon_social` | Nombre completo de la persona o razón social de la empresa |
| `numero_escritura` | Número de la escritura pública de constitución |
| `fecha_constitucion` | Fecha exacta de la constitución: día, mes, año |
| `notario_nombre` | Nombre completo del notario o corredor público |
| `tipo_fedatario` | `"Notaría"` o `"Correduría"` |
| `numero_notaria` | Número de la notaría o correduría |
| `distrito_fedatario` | Distrito o ciudad de adscripción del fedatario |
| `estado_notaria` | Estado de la República Mexicana |
| `lugar_rpp` | Ciudad o localidad del Registro Público de la Propiedad y del Comercio |
| `folio_rpp` | Folio mercantil del RPP |
| `fecha_inscripcion_rpp` | Fecha de inscripción en el RPP: día, mes, año |
| `rfc` | Registro Federal de Contribuyentes de la persona o empresa |


-------------------------------------------------------------------------------------------------------
| Campo | Descripción |
| --------------------------- |
-------------------------------------------------------------------------------------------------- |
| `nombre_representante` | Nombre completo del apoderado o representante legal |
| `numero_poder` | Número de instrumento público en el que se le otorgó el poder |
| `fecha_poder` | Fecha del poder notarial: día, mes, año |
| `notario_poder_nombre` | Nombre del notario/corredor que otorgó el poder |
| `tipo_fedatario_poder` | `"Notaría"` o `"Correduría"` |
| `numero_notaria_poder` | Número de notaría/correduría del fedatario del poder |
| `distrito_fedatario_poder` | Distrito o ciudad del fedatario |
| `estado_fedatario_poder` | Estado |
| `declaracion_no_revocacion` | Booleano o texto libre: Declaración bajo protesta de no haber sido modificado ni
revocado el poder |
